//import 'bootstrap/'
import "bootstrap/js/dist/collapse";
import Header from "./parts/header";
import "./parts/cookiebot";
import "./parts/swipers";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

// if (getCookie('CookieConsent')) {
//   console.log('cookiebot accepted')
// } else {
//   console.log('cookiebot not accepted')
// }

document.addEventListener("DOMContentLoaded", () => {
  const header = new Header();
  header.scrolledHeader();
  header.searchToggle();
  header.mobileMenu();
  header.addClassIfCategory();
});

const heroSections = document.querySelectorAll(".hero_section");

if (heroSections) {
  Array.prototype.forEach.call(heroSections, (heroSection) => {});
}

document.addEventListener("DOMContentLoaded", () => {
  gradTitleEqualizer();
});
window.addEventListener("resize", () => {
  gradTitleEqualizer();
});

function gradTitleEqualizer() {
  let maxListHeight = 0;
  let maxContentHeight = 0;
  const listingSections = document.querySelectorAll(".listing_section");
  if (listingSections) {
    Array.prototype.forEach.call(listingSections, (listingSection) => {
      const listWrapper = listingSection.querySelector(".list-wrapper");
      if (listWrapper) {
        const listcount = listWrapper.getAttribute("data-listcount");
        if (listcount !== 1) {
          let chunkCount = 0;
          if (listcount === "4") {
            chunkCount = 4;
          } else if (listcount === "3") {
            chunkCount = 3;
          } else if (listcount === "2") {
            chunkCount = 2;
          }
          const titles = listWrapper.querySelectorAll(".gradient-title");
          if (titles) {
            let chunkHeight = 0;
            for (let i = 0; i < Array.from(titles).length; i += chunkCount) {
              const chunk = Array.from(titles).slice(i, i + chunkCount);
              Array.prototype.forEach.call(chunk, (tle) => {
                if (chunkHeight < tle.getBoundingClientRect().height) {
                  chunkHeight = tle.getBoundingClientRect().height;
                  tle.style.minHeight = "unset";
                }
              });
              Array.prototype.forEach.call(chunk, (tle) => {
                tle.style.minHeight = `${chunkHeight}px`;
              });
              chunkHeight = 0;
            }
          }

          const subTitles = listWrapper.querySelectorAll(".sub h3");
          if (subTitles) {
            let chunkHeight = 0;
            for (let i = 0; i < Array.from(subTitles).length; i += chunkCount) {
              const chunk = Array.from(subTitles).slice(i, i + chunkCount);
              Array.prototype.forEach.call(chunk, (tle) => {
                if (chunkHeight < tle.getBoundingClientRect().height) {
                  chunkHeight = tle.getBoundingClientRect().height;
                  tle.style.minHeight = "unset";
                }
              });
              Array.prototype.forEach.call(chunk, (tle) => {
                tle.style.minHeight = `${chunkHeight}px`;
              });
              chunkHeight = 0;
            }
          }
        }
      }

      const contentWrapper = listingSection.querySelector(".content-wrapper");
      if (contentWrapper) {
        const titles = contentWrapper.querySelectorAll(".gradient-title");
        if (titles) {
          maxContentHeight = 0;
          Array.prototype.forEach.call(titles, (tle) => {
            if (maxContentHeight < tle.getBoundingClientRect().height) {
              maxContentHeight = tle.getBoundingClientRect().height;
            }
          });
          Array.prototype.forEach.call(titles, (tle) => {
            tle.style.minHeight = `${maxContentHeight}px`;
          });
        }
      }
    });
  }
}

function sliceIntoChunks(arr, chunkSize) {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}

const searchFilters = document.querySelectorAll(".filter-search-results input");
const triggerAllFilters = document.querySelector(
  ".filter-search-results #filter_all"
);
let checkedCount = 0;
if (triggerAllFilters && searchFilters) {
  triggerAllFilters.addEventListener("click", () => {
    if (triggerAllFilters.checked) {
      Array.prototype.forEach.call(searchFilters, (searchFilter) => {
        searchFilter.checked = true;
        checkedCount = 4;
      });
    } else {
      Array.prototype.forEach.call(searchFilters, (searchFilter) => {
        searchFilter.checked = false;
        checkedCount = 0;
      });
    }
  });
  Array.prototype.forEach.call(searchFilters, (searchFilter) => {
    if (searchFilter.getAttribute("id") !== "filter_all") {
      if (searchFilter.checked) {
        checkedCount++;
      }
      searchFilter.addEventListener("click", () => {
        if (searchFilter.checked) {
          checkedCount++;
        } else {
          checkedCount--;
        }
        console.log(checkedCount);
        if (checkedCount > 3) {
          triggerAllFilters.checked = true;
        } else {
          triggerAllFilters.checked = false;
        }
      });
    }
  });
  //console.log(checkedCount);
}

const urlParams = new URLSearchParams(window.location.search);
const formEmailParam = urlParams.get("formEmail");
const formIdParam = urlParams.get("formId");
const formNameParam = urlParams.get("formName");

if (formEmailParam && formIdParam && formNameParam) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "formSubmission",
    formID: `"${formIdParam}"`,
    formName: `"${formNameParam}"`,
    email: `"${formEmailParam}"`,
  });
}

jQuery(document).on(
  "gform_post_render",
  function (event, form_id, current_page) {
    if (form_id === 1 || form_id === 17) {
      const newsLetterSection = document.querySelector(
        ".newsletter-form-section"
      );
      if (newsLetterSection) {
        const emailContainer = newsLetterSection.querySelector(
          ".ginput_container_email"
        );
        const submitButton = newsLetterSection.querySelector(
          ".gform_footer .gform_button"
        );
        if (submitButton && emailContainer) {
          emailContainer.appendChild(submitButton);
        }
      }
    }
  }
);
